import React, { useState } from 'react';
import { Box, Typography } from 'minimal-ui';
import { formatDate } from '../utils/promotionHelpers';

const PromotionInfo = ({ promotionDetails }) => {
    const [showFullDescription, setShowFullDescription] = useState(false);

    return (
        <Box sx={{ px:2, py: 1, flexShrink: 0 }}>
            <Typography
                variant="h5"
                fontWeight={700}
                color="#E27172"
                mb={0.5}
            >
                {promotionDetails?.type || 'N/A'}
            </Typography>

            <Typography variant="h6" mb={0.5}>
                {promotionDetails?.title || 'N/A'}
            </Typography>

            <Typography 
                variant="body2" 
                color="text.secondary" 
        
                sx={{ 
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word'
                }}
            >
                {promotionDetails?.description
                    ? showFullDescription || promotionDetails.description.length <= 50
                        ? promotionDetails.description
                        : promotionDetails.description.slice(0, 50) + '...'
                    : 'N/A'}
                {promotionDetails?.description && promotionDetails.description.length > 50 && !showFullDescription && (
                    <Typography
                        variant="body2"
                        color="primary.dark"
                        sx={{ textDecoration: 'underline', cursor: 'pointer', display: 'inline', ml: 1 }}
                        onClick={() => setShowFullDescription(true)}
                        component="span"
                    >
                        Read More
                    </Typography>
                )}
                {promotionDetails?.description && promotionDetails.description.length > 255 && showFullDescription && (
                    <Typography
                        variant="body2"
                        color="primary.dark"
                        sx={{ textDecoration: 'underline', cursor: 'pointer', display: 'inline', ml: 1 }}
                        onClick={() => setShowFullDescription(false)}
                        component="span"
                    >
                        Show Less
                    </Typography>
                )}
            </Typography>

            <Typography variant="body2" fontWeight={500}>
                Valid: {formatDate(promotionDetails?.start_date)} to {formatDate(promotionDetails?.end_date)}
            </Typography>
        </Box>
    );
};

export default PromotionInfo;

